<template>
  <v-data-table
    :items="scores"
    :headers="computedHeaders"
    :hide-headers="true"
    :hide-actions="true"
    class="elevation-1"
  >
    <template v-slot:items="props">
      <td class="text-xs-right">{{ props.item.rank | formatRank }}</td>
      <td class="text-xs-left">{{ props.item.player_name }}</td>
      <td class="text-xs-right">{{ props.item.value | formatNumber }}</td>
      <td class="text-xs-right" v-if="!$vuetify.breakpoint.smAndDown">{{ props.item.stage_name }}</td>
      <td class="text-xs-left" v-if="!$vuetify.breakpoint.smAndDown">
        <OneCCBadge v-if="props.item.onecc" />
        {{ props.item.comment }}
      </td>
    </template>
  </v-data-table>
</template>
<script>
import OneCCBadge from '@/components/atoms/OneCCBadge';

export default {
  props: ['scores'],
  components: { OneCCBadge },
  computed: {
    computedHeaders() {
      return this.headers.filter(h => !h.hide || !this.$vuetify.breakpoint[h.hide]);
    },
  },
  data() {
    return {
      headers: [
        { text: 'Rank' },
        { text: 'Player' },
        { text: 'Score' },
        { text: 'Stage', hide: 'smAndDown' },
        { text: 'Comment', hide: 'smAndDown' },
      ],
    };
  },
};
</script>
